import { render } from "./CurrencyFilterItem.vue?vue&type=template&id=807a9b40"
import script from "./CurrencyFilterItem.vue?vue&type=script&lang=js"
export * from "./CurrencyFilterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__